
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_lljvd_1evk7_5",
  "inTransition": "awsui_inTransition_lljvd_1evk7_11",
  "transformed": "awsui_transformed_lljvd_1evk7_16",
  "removed": "awsui_removed_lljvd_1evk7_21",
  "dragged": "awsui_dragged_lljvd_1evk7_25",
  "resized": "awsui_resized_lljvd_1evk7_30",
  "hidden": "awsui_hidden_lljvd_1evk7_35"
};
  